var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 51,
    cy: 21,
    r: 20,
    fill: "#02A2A2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_9990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_9990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 66C16.35 66 14.938 65.413 13.764 64.239C12.588 63.063 12 61.65 12 60V12C12 10.35 12.588 8.937 13.764 7.761C14.938 6.587 16.35 6 18 6H39.525C40.325 6 41.088 6.15 41.814 6.45C42.538 6.75 43.175 7.175 43.725 7.725L58.275 22.275C58.825 22.825 59.25 23.462 59.55 24.186C59.85 24.912 60 25.675 60 26.475V36H54V27H42C41.15 27 40.438 26.712 39.864 26.136C39.288 25.562 39 24.85 39 24V12H18V60H36V66H18ZM54.9 43.575L58.125 46.8L46.5 58.35V61.5H49.65L61.275 49.95L64.425 53.1L52.425 65.1C52.125 65.4 51.787 65.625 51.411 65.775C51.037 65.925 50.65 66 50.25 66H43.5C43.1 66 42.75 65.85 42.45 65.55C42.15 65.25 42 64.9 42 64.5V57.75C42 57.35 42.075 56.963 42.225 56.589C42.375 56.213 42.6 55.875 42.9 55.575L54.9 43.575ZM64.425 53.1L54.9 43.575L59.25 39.225C59.8 38.675 60.5 38.4 61.35 38.4C62.2 38.4 62.9 38.675 63.45 39.225L68.775 44.55C69.325 45.1 69.6 45.8 69.6 46.65C69.6 47.5 69.325 48.2 68.775 48.75L64.425 53.1Z",
    fill: "#3E4753"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.92397c63486b77950aef8e5b99957db3.svg";
export { ForwardRef as ReactComponent };